import { createTheme } from '@mui/material/styles';

export const TIRedTheme = createTheme({
  palette: {
    mode: 'light',
    background: { default: '#FFFFFF', paper: '#FFFFFF' },
    primary: {
      main: '#CC0000',
      dark: '#990000',
      veryDark: '#000000',
      light: '#AAAAAA',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#990000',
      dark: '#115566',
      light: '#118899',
      // additional accent color kept as custom key
      accent: '#00bbcc',
      contrastText: '#e0e0e0',
    },
  },
});